<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-double-down`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24.201 27.402l12.075-11.887a1 1 0 00.094-1.32l-.094-.105-1.421-1.4a1 1 0 00-1.403 0L23.5 22.489l-9.952-9.797a1 1 0 00-1.403 0l-1.421 1.399a1 1 0 00-.094 1.319l.094.106 12.074 11.887a1 1 0 001.404 0zm0 9.907l12.075-11.887a1 1 0 00.094-1.319l-.094-.106-1.421-1.399a1 1 0 00-1.403 0L23.5 32.395l-9.952-9.797a1 1 0 00-1.403 0l-1.421 1.4a1 1 0 00-.094 1.319l.094.105L22.798 37.31a1 1 0 001.404 0z"/></svg>
</template>
<script>

export default {
  name: 'IconDoubleDown',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
